import { Link } from 'react-router-dom';
import { Box, Grid, styled, Typography } from '@mui/material';
import { ReactComponent as LogoIcon } from 'assets/icons/logo.svg';
import BackGroundImage from 'assets/images/login-background.svg';

export const StyleItemGrid = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 'auto 0px',
  zIndex: 1,
}));

export const LoginWrapper = styled(Box)(() => ({
  width: '100%',
  height: '100vh',
  position: 'relative',
  overflow: 'hidden',
  '&:before': {
    content: '""',
    // backgroundImage: `url(${BackGroundImage})`,
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: '300px',
    webkitTransform: 'rotateX(0deg) rotateY(180deg) rotateZ(0deg)',
    transform: 'rotateX(0deg) rotateY(180deg) rotateZ(0deg)',
    '-webkit-transform-style': 'preserve-3d',
    transformStyle: 'preserve-3d',
    backgroundPosition: 'bottom',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    '@media (max-width: 1280px)': {
      left: '500px',
    },
    '@media (max-width: 1200px)': {
      content: 'unset',
    },
  },
}));

export const LoginInner = styled(Box)(() => ({
  maxWidth: '330px',
  width: '100%',
}));

export const StyledContainer = styled(Box)(() => ({
  padding: '16px 8px 8px 8px',
  borderRadius: '8px',
}));

export const StyledHeading = styled(Typography)(() => ({
  paddingBottom: '8px',
  textAlign: 'center',
  fontWeight: '600',
}));

export const LoginHead = styled(Box)(() => ({
  textAlign: 'center',
}));

export const StyledLogo = styled(LogoIcon)(() => ({
  height: ' 60px',
  width: '60px',
  marginBottom: ' -10px',
}));

export const StyledLink = styled(Link)(() => ({
  fontSize: '12px',
  fontWeight: '600',
  marginleft: '4px',
  cursor: 'pointer',
  textdecoration: 'none',
  '&:hover ': {
    textdecoration: 'underline',
  },
}));
